import { AppLangs } from "./model/shared/enum/AppLangs.enum";

export function setLangugeAndDir() {
  const params = new URLSearchParams(window.location.search);
  const langParameter = params.get("lang");

  const urlLang = Object.values(AppLangs).find((l) => l === langParameter);

  const langToUse =
    urlLang ||
    ((window.localStorage.getItem("atiraspace_lang") ||
      AppLangs.EN) as AppLangs);

  const direction = langToUse === AppLangs.AR ? "rtl" : "ltr";

  const doc = document.documentElement;
  doc.setAttribute("dir", direction);
  doc.setAttribute("lang", langToUse);
}
